import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { WoExternalComponent } from './working/wo-external/wo-external.component';
import { ExLoginComponent } from './working/wo-external/ex-login/ex-login.component';
import { ExRecoverComponent } from './working/wo-external/ex-recover/ex-recover.component';
import { ExRegisterComponent } from './working/wo-external/ex-register/ex-register.component';

import { WoSystemComponent } from './working/wo-system/wo-system.component';

import { WoTechnologyComponent } from './working/wo-technology/wo-technology.component';
import { TeDomainDataComponent } from './working/wo-technology/te-domain-data/te-domain-data.component';
import { TeDomainExtComponent } from './working/wo-technology/te-domain-ext/te-domain-ext.component';
import { TeGeoCountryComponent } from './working/wo-technology/te-geo-country/te-geo-country.component';
import { TeRoleAuthComponent } from './working/wo-technology/te-role-auth/te-role-auth.component';
import { TeRoleDataComponent } from './working/wo-technology/te-role-data/te-role-data.component';
import { TeRoleFuncComponent } from './working/wo-technology/te-role-func/te-role-func.component';
import { TeRoleGroupComponent } from './working/wo-technology/te-role-group/te-role-group.component';
import { TeRolePermitComponent } from './working/wo-technology/te-role-permit/te-role-permit.component';
import { TeRoleTaskComponent } from './working/wo-technology/te-role-task/te-role-task.component';
import { TeUserDataComponent } from './working/wo-technology/te-user-data/te-user-data.component';
import { TeUserEmailComponent } from './working/wo-technology/te-user-email/te-user-email.component';
import { TeUserIpComponent } from './working/wo-technology/te-user-ip/te-user-ip.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'external/login' },
  {
    path: 'external', component: WoExternalComponent,
    children: [
      { path: 'login', component: ExLoginComponent },
      { path: 'recover', component: ExRecoverComponent },
      { path: 'register', component: ExRegisterComponent },
    ],
  },
  /*{
    path: 'structure',
    component: WoStructureComponent,
    children: [
      { path: 'module', component: WoStModuleComponent },
    ],
  },*/
  {
    path: 'system',
    component: WoSystemComponent,
    children: [
      //{ path: 'authentication', component: WoSyAuthenticationComponent },
      //{ path: 'information', component: WoSyInformationComponent },
    ],
  },
  {
    path: 'technology',
    component: WoTechnologyComponent,
    children: [
      { path: 'domain',
        children: [
          { path: 'data', component: TeDomainDataComponent },
          { path: 'ext', component: TeDomainExtComponent },
        ],
      },
      { path: 'geo',
        children: [
          { path: 'country', component: TeGeoCountryComponent },
        ],
      },
      { path: 'role',
        children: [
          { path: 'auth', component: TeRoleAuthComponent },
          { path: 'data', component: TeRoleDataComponent },
          { path: 'func', component: TeRoleFuncComponent },
          { path: 'group', component: TeRoleGroupComponent },
          { path: 'permit', component: TeRolePermitComponent },
          { path: 'task', component: TeRoleTaskComponent },
        ],
      },
      { path: 'user',
        children: [
          { path: 'data', component: TeUserDataComponent },
          { path: 'email', component: TeUserEmailComponent },
          //{ path: 'entry', component: TeUserEntryComponent },
          { path: 'ip', component: TeUserIpComponent },
        ],
      },
    ],
  },
  { path: '**', redirectTo: 'external/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
